import { render } from "./sectionHeader.vue?vue&type=template&id=03b0eecf&ts=true"
import script from "./sectionHeader.ts?vue&type=script&lang=ts"
export * from "./sectionHeader.ts?vue&type=script&lang=ts"

import "./sectionHeader.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__